// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface BrandDetailsHeaderWrapperStyles {
    container?: InjectableCss;
    innerContainer?: InjectableCss;
}

export const headerWrapperStyles: BrandDetailsHeaderWrapperStyles = {
    container: {
        css: css`
            padding-top: 10px;
            padding-bottom: 30px;
            width: 100%;
            border-bottom: 1px solid ${getColor("common.border")};
            margin-bottom: 30px;

            &:last-child {
                border: none;
                margin-bottom: 0;
            }
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: -15px;
            width: auto;
            & > ${StyledWrapper} {
                padding: 15px;
            }
        `,
    },
};

const styles = headerWrapperStyles;

const BrandDetailsHeaderSection = ({ id }: WidgetProps) => {
    return (
        <StyledWrapper {...styles.container}>
            {createWidgetElement("BrandDetails/BrandDetailsLinks", {} as any)}
            <StyledWrapper {...styles.innerContainer}>
                {createWidgetElement("BrandDetails/BrandDetailsLogo", {} as any)}
                {createWidgetElement("BrandDetails/BrandDetailsContent", {} as any)}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsHeaderSection,
    definition: {
        group: "Brand Details",
        icon: "Image",
        displayName: "Brand Header Section",
        allowedContexts: [BrandDetailsPageContext],
    },
};

export default widgetModule;
